import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import type { NavItemProps } from '../CustomNavLink';
import { MOD_PROFILE_ENTRY_TEXT } from '../../../../constants/modification.strings';

// The buyer's way in to their own AI modifications (Joey, 2026-10-30). Drawn
// exactly as the Upload and Review items are, with the sparkle My profile's entry
// has and the same words as its accessible name.
const Modifications = ({ ActiveComp }: NavItemProps) => (
  <Box
    sx={(theme) => ({
      alignItems: 'center',
      borderLeft: `1px solid ${theme.palette.divider}`,
      color: ActiveComp ? theme.palette.primary.main : 'inherit',
      display: 'flex',
      height: '100%',
      justifyContent: 'center',
      padding: '1rem',
    })}
  >
    <IconButton size="small" color="inherit" aria-label={MOD_PROFILE_ENTRY_TEXT}>
      <AutoAwesomeOutlinedIcon />
    </IconButton>
    {ActiveComp && <ActiveComp />}
  </Box>
);

export default Modifications;
